<script src="./PaymentMethod.js"></script>
<i18n src="./PaymentMethod.txt" lang="yaml"></i18n>

<template>
  <span>
    <div class="checkout-shipping-content">
      <div class="shipping-content-left">
        <span class="bold-text">{{
          t('paymentMethod')
        }}</span>
      </div>
    </div>

    <div
      class="payment-method"
      v-for="method in paymentMethods"
      :key="method.name"
    >
      <div class="pay-top sin-payment d-flex mb-2">
        <input
          :id="method.name"
          v-model="pm"
          class="input-radio"
          type="radio"
          :value="method.name"
          name="payment_method"
        />
        <label :for="method.name"
          >{{ t(method.description) }}
          <img
            class="payment-method-img"
            :src="getImgUrl(method.image)"
        /></label>
      </div>
      <div v-if="pm === 'card' && method.name === 'card'">
        <label for="cname">Name on Card</label>
        <input type="text" id="cname" name="cardname" placeholder="John More Doe">
            
        <label for="ccnum">Credit card number</label>
        <input type="text" id="ccnum" name="cardnumber" placeholder="1111-2222-3333-4444">
            
        <label for="expmonth">Exp Month</label>
        <input type="text" id="expmonth" name="expmonth" placeholder="September">
        
        <div class="row">
          <div class="col-6">
            <label for="expyear">Exp Year</label>
            <input type="text" id="expyear" name="expyear" placeholder="2018">
          </div>
          <div class="col-6">
            <label for="cvv">CVV</label>
            <input type="text" id="cvv" name="cvv" placeholder="352">
          </div>
        </div>
      </div>
    </div>
  </span>
</template>
